import React from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { FLOWS_ENUM } from '../../common/enums';
import Success from '../../components/payment/common/success/Success';
import RenewSuccessFields from '../../components/payment/common/success/RenewSuccessFields';
import { useLocation } from 'react-router-dom';

const RenewSuccess = () => {
  const location = useLocation();
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.RENEW_LICENSE} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as="main"
        id="main-content"
        tabIndex={-1}
        colspan={24}
        aria-label="Renewal submitted"
      >
        <Content as="div">
          <Success
            flow={FLOWS_ENUM.RENEW_LICENSE}
            successComponent={() => (
              <RenewSuccessFields
                isBulkRenew={location?.state?.isBulkRenew ?? false}
              />
            )}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default RenewSuccess;
